import { render, staticRenderFns } from "./DependedFieldModal.vue?vue&type=template&id=139d9d6a&scoped=true"
import script from "./DependedFieldModal.vue?vue&type=script&lang=js"
export * from "./DependedFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d9d6a",
  null
  
)

export default component.exports